import type {
  GetProcessorInstancesByProcessorQuery,
  GetProcessorInstancesByProcessorQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_PROCESSOR_INSTANCES_BY_PROCESSOR: TypedDocumentNode<
  GetProcessorInstancesByProcessorQuery,
  GetProcessorInstancesByProcessorQueryVariables
> = gql`
  query GetProcessorInstancesByProcessor($processorId: String!, $limit: Int) {
    processorInstances(processorId: $processorId, limit: $limit) {
      id
      processorId
      userId
      isActive
      error
      createdAt
      updatedAt
    }
  }
`;
